<div class="row">
  <div class="col-12">
    <h1 class="h2 mb-7">{{ 'habaCustomerData.invoiceDownload.headline' | cxTranslate }}</h1>
    <h4 class="mb-7">{{ 'habaCustomerData.invoiceDownload.secondHeadline' | cxTranslate }}</h4>
    <p>{{ 'habaCustomerData.invoiceDownload.descriptionPart1' | cxTranslate }}</p>
    <p>{{ 'habaCustomerData.invoiceDownload.descriptionPart2' | cxTranslate }}</p>
    <p>{{ 'habaCustomerData.invoiceDownload.descriptionPart3' | cxTranslate }}</p>
  </div>
  <div class="col-12 col-md-8 col-lg-6">
    <form [formGroup]="invoicePdfDownload" class="mt-7">
      <app-form-input>
        <app-form-label>{{
          'habaCustomerData.invoiceDownload.inputCustomerNr' | cxTranslate
        }}</app-form-label>
        <input appFormInput type="text" formControlName="customerNr" />
        <app-form-error>{{
          'habaCustomerData.invoiceDownload.inputCustomerNrError' | cxTranslate
        }}</app-form-error>
      </app-form-input>
      <app-form-input>
        <app-form-label>{{
          'habaCustomerData.invoiceDownload.inputInvoiceNr' | cxTranslate
        }}</app-form-label>
        <input appFormInput type="text" formControlName="invoiceNr" />
        <app-form-error>{{
          'habaCustomerData.invoiceDownload.inputInvoiceNrError' | cxTranslate
        }}</app-form-error>
      </app-form-input>
      <button
        class="btn btn-primary btn-center mt-9"
        (click)="getInvoicePdfDownload()"
        [disabled]="invoicePdfDownload.invalid"
      >
        {{ 'habaCustomerData.invoiceDownload.submitButton' | cxTranslate }}
      </button>
    </form>
  </div>
</div>
